import React from "react"
import styled from "styled-components"

const StyledListTitle = styled.span`
  font-weight: bold;
`
export default function ListTitle({ title }) {
  return <StyledListTitle>{title}</StyledListTitle>
}
